import { CommonModule } from '@angular/common';
import { Component, Input, afterNextRender, signal } from '@angular/core';
import { SwiperService } from '@shared/services/swiper-config.service';

@Component({
 selector: 'iho-popular-cities',
 templateUrl: './popular-cities.component.html',
 styleUrls: ['./popular-cities.component.scss'],
 standalone: true,
 imports: [CommonModule],
})
export class PopularCitiesComponent {
 configSwiper: any;
 resetSwiper = signal(true);
 cities$: any = [
  {
   Name: 'هتل های مشهد',
   Url: '/mashhad-hotels/',
   PictureUrl: 'Layer 3.webp',
   Count: 409,
   span: 'row-span-2',
  },
  // {
  //   Name: 'هتل های شیراز',
  //   Url: '/shiraz-hotels/',
  //   PictureUrl:
  //     'https://cdn.iranhotelonline.com/Application_Image/Around/Top/534.webp',
  //   Count: 84,
  // },
  {
   Name: 'هتل های تهران',
   Url: '/tehran-hotels/',
   PictureUrl: 'Layer 4.webp',
   Count: 131,
   span: 'row-span-2',
  },
  {
   Name: 'هتل های تبریز',
   Url: '/tabriz-hotels/',
   PictureUrl: 'Layer 7.webp',
   Count: 40,
   span: 'row-span-1',
  },
  {
   Name: 'هتل های کرمان',
   Url: '/kerman-hotels/',
   PictureUrl: 'Layer 2.webp',
   Count: 18,
   span: 'row-span-1',
  },
  {
   Name: 'هتل های کیش',
   Url: '/kish-hotels/',
   PictureUrl: 'Layer 6.webp',
   Count: 46,
   span: 'row-span-1',
  },
  {
   Name: 'هتل های اصفهان',
   Url: '/isfahan-hotels/',
   PictureUrl: 'Layer 5.webp',
   Count: 83,
   span: 'row-span-1',
  },
 ];
 cities: any[] = [];
 @Input({ required: true })
 get dataSource(): any {
  return this._dataSource;
 }
 set dataSource(value: any) {
  this._dataSource = value;
  // this.cities = (this.cities$ as any[])
  //   .map((item: any, index) => ({
  //     ...item,
  //     span: [1, 1, 1, 1, 2, 2][index],
  //   }))
  //   .filter((city: any) => {
  //     var cityName: any = [city.Name];
  //     return cityName?.some((item: string) => {
  //       return ['کرمان', 'مشهد', 'تهران', 'اصفهان', 'تبریز', 'کیش'].includes(
  //         item.split(' ')[2]
  //       );
  //     });
  //   });
 }
 private _dataSource!: any;

 constructor(private swiperService: SwiperService) {
  afterNextRender(() => {
   this.resetSwiper.set(false);
   setTimeout(() => this.resetSwiper.set(true), 0);
  });
 }

 ngOnInit() {
  let config = {
   slide: 'auto',
   pagination: {
    enabled: false,
    clickable: false,
   },
  };

  this.configSwiper = this.swiperService.SwiperConfig(config);
 }
}
